import hand from "../../images/Svg/hand.svg";
import people from "../../images/Svg/people.svg";
import invest from "../../images/Svg/invest.svg";
import DiscordIcon from "../../images/Svg/DiscordBlack.svg";

const AboutData = [
  {
    id: 1,
    icon: hand,
    title:
      "<span className='ml-4 text-justify sm:text-justify md:text-center'>Try out our product</span>",
  },
  {
    id: 2,
    icon: people,
    title:
      "<span className='ml-4 text-justify sm:text-justify md:text-center'> Follow us on DeSo apps</span>",
  },
  {
    id: 3,
    icon: invest,
    title:
      "<span className='ml-4 text-justify sm:text-justify md:text-center'>Invest in Setu <a href='https://diamondapp.com/u/setu_deso' target='_blank' rel='noopener noreferrer'  className='text-[#7F8AFF] underline underline-offset-1'>here</a></span>",
  },
  {
    id: 4,
    icon: DiscordIcon,
    title:
      "<span className='ml-4 text-justify sm:text-justify md:text-center'>Join our community on discord</span>",
  },
];

export default AboutData;
